module.exports = __webpack_public_path__ + "img/20190925171342215.0055c223.jpg";